module.exports = __webpack_public_path__ + "static/img/img28.a1f82379.png";